@if(customerResource.isLoading())
{
    <div class="d-flex flex-column justify-content-center align-items-center w-100" style="height: 100vh;">
        <div class="continuous-loader" role="status"></div>
        <h4 class="mt-2">Indlæser kundens data..</h4>
    </div>
}
@else
{
    <div>
        <div class="row mt-5">
            <div class="col-xl-6 mb-3 mb-xl-0">
                <div class="card h-100">
                    <div class="card-header bg-transparent">
                        <h5 class="me-auto mt-1">Stamdata for Kunde med id: {{customer().customerId}}</h5>
                    </div>
                    <div class="card-body">
                        <app-customer-masterdata [(errorMessage)]="errorMessage" [(customer)]="customer"
                            (formSubmitted)="saveCustomer($event)"
                            (isValidChanged)="updateCanSave($event)"></app-customer-masterdata>
                    </div>
                    <div class="card-footer bg-transparent">
                        <button class="btn btn-success my-2 float-end"
                            [disabled]="!canSaveCustomer() || isUpdatingCustomer()" (click)="submitForm()">
                            @if(isUpdatingCustomer())
                        {
                                <div class="spinner-border spinner-border-sm me-2" role="status">
                                    <span class="visually-hidden">Gemmer...</span>
                                </div>
                            }
                            Gem
                        </button>
                    </div>
                </div>
            </div>
            <div class="col-xl-6">
                <div class="card h-100">
                    <div class="card-header bg-transparent">
                        <div class="d-flex mb-3">
                            <h5 class="me-auto mt-1">Regnskaber</h5>
                            <td scope="row" (click)="$event.stopPropagation()" class="text-end">
                                <button class="btn btn-primary" (click)="onShowCreateCompany($event)"
                                    ngbTooltip="Opret regnskab"><i class="fas fa-plus fa-xs"></i><i
                                        class="fas fa-table"></i>
                                    Opret regnskab</button>
                            </td>

                        </div>
                    </div>

                    <div class="card-body company-card-body">
                        <app-customer-company-table [customerId]="customer().customerId"></app-customer-company-table>
                    </div>
                </div>

            </div>
        </div>
    </div>

}